import { schema } from 'normalizr';

const settingRolesSchema = [new schema.Entity('roles')];

export {
  // eslint-disable-next-line import/prefer-default-export
  settingRolesSchema,
};
